module.exports = __webpack_public_path__ + "static/media/dot.bf430808.svg";